var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M4.444 3.367V1.589c0-.491.398-.889.89-.889h5.333c.49 0 .889.398.889.889v1.778h3.555a.889.889 0 0 1 0 1.777v10.667a3.556 3.556 0 0 1-3.555 3.556H4.444A3.556 3.556 0 0 1 .89 15.81V5.144a.889.889 0 1 1 0-1.777h3.555zM2.667 5.144v10.667c0 .982.796 1.778 1.777 1.778h7.112c.981 0 1.777-.796 1.777-1.778V5.144H2.667zm2.666 2.667a.889.889 0 1 1 1.778 0v7.111a.889.889 0 0 1-1.778 0v-7.11zm3.556 0a.889.889 0 0 1 1.778 0v7.111a.889.889 0 0 1-1.778 0v-7.11zM6.222 3.367h3.556v-.89H6.222v.89z", id: "svg4113777307a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(2)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg4113777307b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg4113777307a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg4113777307a" }),
      React.createElement(
        "g",
        { mask: "url(#svg4113777307b)", fill: "currentColor" },
        React.createElement("path", { d: "M-2 0h20v20H-2z" })
      )
    )
  );
});